// extracted by mini-css-extract-plugin
export default {"Blanket":"Blanket_Blanket__6uu1g","Close":"Blanket_Close__tNg6G"};